//Predictive search API call is in theme.liquid


var isItTrue = true;
var scrollVar = false;

$(document).ready(function () {
  window.onscroll = function () {
    stickyAnnouncementBarOnScroll()
  };

  function toggleFilterMenu() {
    var toggle_text = $('#toggle-filter .toggle-filter-text').text();

    $("#rockport-container .collection-section").toggleClass("filter-hide");

    if (toggle_text == 'Open filter') {
      $('#toggle-filter .toggle-filter-text').text("Close filter");

    } else {
      $('#toggle-filter .toggle-filter-text').text("Open filter");
    }
  }


  if (window.innerWidth < 768) {
    if ($('#rockport-container .collection-section').length > 0) {
      if ($("#rockport-container .collection-section .filter-hide").length === 0) {
        toggleFilterMenu();
      }
    }
  }


  function stickyAnnouncementBarOnScroll() {
    if (window.pageYOffset > 50) {
      $("#announcement-wrapper").addClass("sticky")
    } else {
      $("#announcement-wrapper").removeClass("sticky")
    }
  }



  /*announcment bar slider */

  $('.announcement-slider').slick({

    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    speed: 1000,
    arrows: false,
    adaptiveHeight: true,
    dots: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 7000,
          speed: 1000,
          arrows: false,
          dots: false
        }
      }
    ]
  });


  $('.slick-class-product').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 1000,
    arrows: true,
    dots: true,
    responsive: [
      {

        breakpoint: 600,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 7000,
          speed: 1000,
          arrows: true,
          dots: true
        }
      }
    ]
  });

  $('.collection-slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 7000,
    speed: 1000,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 7000,
          speed: 1000,
          arrows: false,
          dots: false
        }
      }
    ]
  });


  function toggleSearch() {
    $("#open_cble").toggleClass("opened");
    $(".ui-widget-overlay").toggleClass("opened-search");
    $("#open_cble input").focus();
    $(".logo-icons__right").toggle();
  }

  function closeSearch() {
    $(".pred-placeholder").show();
    $(".pred-content").removeClass("has-pred");
    $('input[name="q"]').val('');

    $("#open_cble").removeClass("opened");
    $(".logo-icons__right").show();
    $(".ui-widget-overlay").removeClass("opened-search");
  }

  function openMobileMenu() {
    isItTrue = false;
    scrollVar = true;
    $("body").toggleClass('shown-mobile-menu');
    $('.navigation-col').addClass('active');
    $("#open-side__menu").removeClass('fa-bars').addClass('fa-plus');
  }

  function closeMobileMenu() {
    $("#mobile-menu-button-close").off("click");
    isItTrue = true
    scrollVar = false;
    $("body").toggleClass('shown-mobile-menu');
    $(".navigation-col").removeClass('active');
    $("#open-side__menu").removeClass('fa-plus').addClass('fa-bars');
  }

  $("#btn__switch").click(function() {
      console.log('open search');
      toggleSearch();
  })

  $(".ui-widget-overlay, .pred-search-button-close").click(function() {
      closeSearch();
  })

  $('.cd-accordion__input').click(function () {
    var cd = this;
    var cd_res = $(cd).next().find("svg").toggleClass("rotate_svg")
  })

  $('#toggle-filter').click(function () {
    $('.filter-menu').toggleClass("d-flex");
    $('.filter-icon').toggleClass("filter-active");

    toggleFilterMenu();
  })

  $('.open-fit').click(function () {
    $('.fit-reviews-mask').css("display", "block")
    $('.fit-reviews').css("display", "block")
  })

  // $(".side-filter-menu .filter-group h4").click(function() {

  // });

  $('.filter-group h4').click(function () {
    var curvar = this;
    var newvar = $(this).next();
    $(curvar).children().toggleClass('extra');
    $(newvar).toggleClass("d-none");

    $(this).prevAll().toggleClass('filter-active')
  });


  /*mobile hamburger menu */

  $('.mobile-menu-button-toggle').click(function () {
    if (isItTrue == true) {
      openMobileMenu();

      $("#mobile-menu-button-close").on("click", function () {
        closeMobileMenu();
      });
    } else {
      closeMobileMenu();
    }
  });

  $("#btn__mobile-search-button").click(function() {
    closeMobileMenu();
    toggleSearch();
  });


  $(".mobile-menu-expand-submenu").click(function() {
    $(this).closest(".menu-container").toggleClass('mobile-opened-submenu');
    $(this).closest(".menu-container").find(".submenu").toggleClass('mobile-show-submenu');
    $(this).toggleClass('mobile-opened-submenu');
  })

  $(".mobile-menu-expand-subsubmenu").click(function() {
    $(this).closest(".submenu-link").find(".subsubmenu").toggleClass('mobile-show-subsubmenu');
    $(this).toggleClass('mobile-opened-subsubmenu');
  });


  $('html').click(function (e) {
    if (e.target.id !== "pt-sort-options" && $(".pt-sort-options").length > 0) {
      // $(".pt-sort-options").hide();
      //do stuff
    }
  });

  var openedSortBy = false;

  function removeSortByClickDetection() {
    $("html").off("click");
  }

  function detectSortByClickOff() {
    $("html").click(function (e) {
      console.log(e);
      console.log(openedSortBy);
      if (openedSortBy && e.target.id !== "pt-sort-options" && $(".opened-sort-options").length > 0) {
        $(".pt-sort-options").removeClass('opened-sort-options');
      }
    });
  }


  $(".pt-sort-button-toggle").click(function() {
    $(".pt-sort-options").toggleClass('opened-sort-options');
    // if($('.opened-sort-options').length > 0) {
    //   openedSortB = true;
    //   detectSortByClickOff();
    // } else {
    //   openedSortBy = false;
    //   removeSortByClickDetection();
    // }
  })
  

});